module.exports = __webpack_public_path__ + "media/icons/mp3@2x-108e5b7b.png";